import { Row } from 'antd';
import { useError } from 'hooks/useError';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { OperatorList } from './components/OperatorList';

export const Operators = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.OPERATOR);
  const errorMessagesJson = t('errorCodes', { returnObjects: true });

  useError('13001', errorMessagesJson);
  useError('13002', errorMessagesJson);

  return (
    <div className="operator">
      <Row>
        <h2 className="bold uppercase">{t('pageTitle')}</h2>
      </Row>
      <OperatorList />
    </div>
  );
};
